import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class {
  constructor() {
    //this.hero();
    this.loading();
    this.hero02();
    this.scroll();
    this.text();
    this.jobAnchor();
  }
  loading() {
    const loading = document.getElementById('loading');
    const loadText = document.querySelector('.js-loading-text');
    const loadingBg = document.querySelector(".js-loading-bg");
    if (loading) {
      if (sessionStorage.getItem('visit')) {
        loading.style.display = "none";
        window.addEventListener("load", () => {
          setTimeout(() => {
            //innerStart.classList.remove('is-hidden');
          }, 500);
        });
      } else {
        sessionStorage.setItem('visit', 'true');
        window.addEventListener("load", () => {
          setTimeout(() => {
            loading.style.opacity = 1;
            loadAnm();
          }, 500);
          setTimeout(() => {
            loading.classList.add("is-finished");
          }, 2000);
          setTimeout(() => {
            loading.style.display = "none";
          }, 2500);
          setTimeout(() => {
            //innerStart.classList.remove('is-hidden');
          }, 2800);
        });
      }
    }

    function loadAnm() {
      const loadTl = gsap.timeline();
      loadTl.to(loadingBg, {
        opacity: 0,
        duration: 0.5,
        delay: 1,
      }).to(loadText, {
        top: '45%',
        duration: 0.6,
      }, '<').to(loadText, {
        opacity: 0,
        duration: 0.5,
        ease: "power4.out",
      }, '<');
    }
  }

  hero02() {
    const windowW = window.innerWidth;
    const windowH = window.innerHeight;
    const hero = document.querySelector('.js-index-hero');
    if (hero) {
      const wrapper = document.querySelector('.js-hero-wrapper');
      const bg = document.querySelector('.js-hero-bg');
      const introSec = document.querySelector(".js-hero-intro");
      const text = document.querySelector(".js-mv-text");
      const mvBg = document.querySelector(".js-mv-bg");
      const img01 = document.querySelector(".js-mv-img01");
      const img02 = document.querySelector(".js-mv-img02");
      const img03 = document.querySelector(".js-mv-img03");
      const img04 = document.querySelector(".js-mv-img04");
      const img05 = document.querySelector(".js-mv-img05");
      const img06 = document.querySelector(".js-mv-img06");
      const img07 = document.querySelector(".js-mv-img07");
      const img08 = document.querySelector(".js-mv-img08");
      const img09 = document.querySelector(".js-mv-img09");
      const img10 = document.querySelector(".js-mv-img10");
      const img11 = document.querySelector(".js-mv-img11");

      const heroAnim = document.querySelector('.js-hero-anim');
      const heroAnimItem = gsap.utils.toArray('.js-hero-anim__item');
      const heroAnimH = heroAnim.clientHeight;

      const scrollNum = document.querySelector('.js-scroll-num');

      let tl;
      let tlAnm;

      ScrollTrigger.create( {
        //markers: true,
        trigger: heroAnim,
        start: 'top top',
        end: `+=${heroAnimH}`,
        pin: true,
        pinSpacing: false,
      })
      heroAnimItem.forEach((item,index) => {
        //console.log((heroAnimH / 4) * index , (heroAnimH / 4) * (index + 1));
        let tlAnm = gsap.timeline({
          scrollTrigger :{
            //markers: true,
            trigger: item,
            start: `${(heroAnimH / 4) * (index)} start`,
            end: `${(heroAnimH / 4) * (index + 1)} bottom`,
            onEnter: () => {
              heroAnimItem.forEach(el => {
                el.classList.remove('is-active');
              });
              item.classList.add('is-active');
              hero.classList.remove(`is-scene0${index}`)
              hero.classList.add(`is-scene0${index + 1}`)
              scrollNum.innerHTML = index + 1;
            },
            onLeaveBack: () => {
              item.classList.remove('is-active');
              if (index == 0) {
                heroAnimItem[0].classList.add('is-active');
                hero.classList.add(`is-scene01`)
                scrollNum.innerHTML = 1;
              } else {
                heroAnimItem[index - 1].classList.add('is-active');
                hero.classList.remove(`is-scene0${index + 1}`)
                hero.classList.add(`is-scene0${index}`)
                scrollNum.innerHTML = index;
              }
            }
          }
        })
      });
      window.addEventListener('load', () => {
        if (window.scrollY < 100) {
          document.querySelector('.js-hero-anim__item.-item01').classList.add('is-active');
        }
      })
      window.addEventListener('scroll', () => {
        let current;
        heroAnimItem.forEach((element,index) => {
          current = index + 1;
        });
      });

      const pinH =  (introSec.clientHeight - bg.clientHeight);
      ScrollTrigger.create( {
        //markers: true,
        trigger: bg,
        start: 'top top',
        end: `+=${pinH}`,
        pin: true,
      })
      gsap.set(text, {
        opacity: 0,
      })

      //timeline
        window.addEventListener("load", () => {
          updateTimeline();
        });
        window.addEventListener("resize", () => {
          updateTimeline();
        });
        function updateTimeline() {
          if (1008 <= windowW) {
            tl = largeAnm(); // タイムラインを代入
          } else {
            tl = smallAnm(); // タイムラインを代入
          }
        }
        const tlBg = gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: introSec,
            //markers: true,
            start: '55% 50%',
            toggleActions: 'play pause play reverse',
            onLeave: () => {
              text.classList.add("is-active");
              //console.log(1);
            },
            onLeaveBack: () => {
              text.classList.remove("is-active");
              //console.log(3);
            },
            onEnterBack: () => {
              text.classList.add("is-active");
              //console.log(2);
            }
          }
        });

        function smallAnm() {
          const tl = gsap.timeline({
            paused: true,
            //markers: true,
            scrollTrigger: {
              trigger: introSec,
              start: '20% 50%',
              toggleActions: 'play pause play reverse',
            }
          });
          //small
          tl.to(text, {
            opacity: 1
          }, "<").to(mvBg, {
            opacity: 0,
          }, "<").to(img01, {
            bottom: -294,
          }, "<").to(img02, {
            top: -280,
            left: -148,
          }, "<").to(img03, {
            top: -321,
            right: -64,
          }, "<").to(img04, {
            top: -400,
            right: -138,
          }, "<").to(img05, {
            top: -241,
            right: -207,
          }, "<").to(img06, {
            right: -167,
            bottom: -358,
          }, "<").to(img07, {
            left: 121,
            bottom: -158,
          }, "<").to(img08, {
            left: -168,
            bottom: -393,
          }, "<").to(img09, {
            left: -194,
            bottom: -190,
          }, "<").to(img10, {
            top: -121,
            left: -260,
          }, "<").to(img11, {
            top: -390,
            left: -217,
          }, "<");
          return tl;
        }

        function largeAnm() {
          const tl = gsap.timeline({
            paused: true,
            scrollTrigger: {
              trigger: introSec,
              //markers: true,
              start: '20% 50%',
              toggleActions: 'play pause pause reverse',
            }
          });

          //large
          tl.to(text, {
            opacity: 1
          }, "<").to(mvBg, {
            opacity: 0,
          }, "<").to(img01, {
            bottom: "calc( -540 / 1080 * 100vh)",
          }, "<").to(img02, {
            top: "calc( -443/ 1080 * 100vh)",
            left: "calc( -364 / 1920 * 100vw)",
          }, "<").to(img03, {
            top: "calc( -560/ 1080 * 100vh)",
            right: "calc( -270 / 1920 * 100vw)",
          }, "<").to(img04, {
            top: "calc( -454 / 1080 * 100vh)",
            right: "calc( -690 / 1920 * 100vw)",
          }, "<").to(img05, {
            top: "calc( -260/ 1080 * 100vh)",
            right: "calc( -999 / 1920 * 100vw)",
          }, "<").to(img06, {
            bottom: "calc( -485/ 1080 * 100vh)",
            right: "calc( -848 / 1920 * 100vw)",
          }, "<").to(img07, {
            bottom: "calc( -410/ 1080 * 100vh)",
            left: "calc( 500 / 1920 * 100vw)",
          }, "<").to(img08, {
            bottom: "calc( -475/ 1080 * 100vh)",
            left: "calc( -913 / 1920 * 100vw)",
          }, "<").to(img09, {
            bottom: "calc( -41 1 / 1080 * 100vh)",
            left: "calc( -652 / 1920 * 100vw)",
          }, "<").to(img10, {
            top: "calc( -184/ 1080 * 100vh)",
            left: "calc( -1031 / 1920 * 100vw)",
          }, "<").to(img11, {
            top: "calc( -558/ 1080 * 100vh)",
            left: "calc( -780 / 1920 * 100vw)",
          }, "<");
          return tl;
        }
        //透明
        tlBg.to([img01, img02, img03, img04, img05, img06, img07, img08, img09, img10, img11], {
          opacity: 0.1,
        }).to(text, {
          opacity: 0,
        }, "<");
    }
  }

  scroll() {
    const skipItem = document.querySelector('.js-skip');
    if (skipItem) {
      const heroAnim = document.querySelector('.js-hero-anim');
      const heroAnimH = heroAnim.clientHeight;
      //console.log(windowH);
      gsap.to(skipItem, {
        scrollTrigger: {
          trigger: skipItem,
          end: `+=${heroAnimH}`,
          //markers: true,
          pin: true,
        }
      });
    }
  }
  text() {
    const textList = document.querySelectorAll('.js-text-view');
    if (textList) {
      textList.forEach(text => {
        var cont = text.textContent;
        var newText = '<span class="js-text-view__in">' + cont + '</span>';
        text.innerHTML = newText;

        let textH = text.clientHeight;
        text.style.height = `${textH}px`;
      });
    }
  }
  jobAnchor() {
    const wrapper = document.querySelector('.js-job-wrapper');
    if (wrapper) {
      const anchorPin = function () {
        const anchor = document.querySelector('.js-job-anchor');
        const wrapperH = wrapper.clientHeight;
        ScrollTrigger.create({
          trigger: anchor,
          start: 'top top',
          end: `+=${wrapperH} 100%`,
          pin: true,
        });
      };

      window.addEventListener('load', () => {
        let windowW = window.innerWidth;
        if (windowW >= 1200) {
          anchorPin();
        }
      });

      window.addEventListener('resize', () => {
        let windowW = window.innerWidth;
        setTimeout(() => {
          if (windowW >= 1200) {
            anchorPin();
          } else {
            ScrollTrigger.killAll();
          }
        }, 500);
      });
    }
  }
}